import { getPendingTransactions } from '../../api/transactions'
import { useAuthQuery } from '@/hooks/use-auth-query'

const useGetPendingTransactions = () => {
  return useAuthQuery({
    queryKey: ['pending_transactions'],
    queryFn: getPendingTransactions,
  })
}

export default useGetPendingTransactions
